import Order from "../sharedPages/app/Order";
import React from "react";

const OrderApp = () => {
  return (
    <div className="container">
      <div className="row justify-content-center h-100 support_wrapper">
        <div className="copyTrade">
          <div className="tab-content">
            <div className="AppTab">
              <Order />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderApp;
